import C from "./constants";
import { combineReducers } from "redux";

const header_text = (state = "", action) => {
  switch (action.type) {
    case C.SET_HEADER:
      return action.payload;
    case C.CLEAR_HEADER:
      return "";
    default:
      return state;
  }
};
const intro = (state = [], action) => {
  switch (action.type) {
    case C.SET_INTRO:
      return action.payload;
    case C.REMOVE_INTRO:
      return [];
    default:
      return state;
  }
};
const lineImage = (state = null, action) => {
  switch (action.type) {
    case C.SET_LINE_IMAGE:
      return action.payload;
    case C.REMOVE_LINE_IMAGE:
      return null;
    default:
      return state;
  }
};
export const ads = (state = [], action) => {
  switch (action.type) {
    case C.ADD_AD:
      return [...state, action.payload];
    case C.REMOVE_AD:
      return state.filter(ad => ad.id !== action.payload);
    case C.SET_ADS:
      return action.payload;
    default:
      return state;
  }
};
export const question = (state = [], action) => {
  switch (action.type) {
    case C.ADD_QUESTION:
      return [...action.payload, ...state];
    case C.UPDATE_QUESTION:
      return state.map(question => {
        return question.id !== action.payload.id ? question : action.payload;
      });
    case C.REMOVE_QUESTION:
      return state.filter(question => question.id !== action.payload);
    case C.SET_QUESTIONS:
      return action.payload;
    default:
      return state;
  }
};
export const clipBoardQuestion = (state = [], action) => {
  switch (action.type) {
    case C.ADD_CB_QUESTION:
      return [...state, ...action.payload];
    case C.UPDATE_CB_QUESTION:
      return state.map(question => {
        return question.id !== action.payload.id ? question : action.payload;
      });
    case C.REMOVE_CB_QUESTION:
      return state.filter(question => question.id !== action.payload);
    case C.SET_CB_QUESTIONS:
      return action.payload;
    default:
      return state;
  }
};
export const category = (state = [], action) => {
  switch (action.type) {
    case C.ADD_CATEGORY:
      return [...state, action.payload];
    case C.SET_CATEGORY:
      return action.payload;
    case C.UPDATE_CATEGORY:
      return state.map(category => {
        return category.id !== action.payload.id ? category : action.payload;
      });
    case C.REMOVE_CATEGORY:
      return state.filter(category => category.id !== action.payload);
    default:
      return state;
  }
};

export const domain_resourses = (state = null, action) => {
  switch (action.type) {
    case C.ADD_DOMAIN_RESOURCE:
      return [...action.payload, ...state];
    case C.SET_DOMAIN_RESOURCE:
      return action.payload;
    case C.UPDATE_DOMAIN_RESOURCE:
      return state.map(resource => {
        return resource.id !== action.payload.id ? resource : action.payload;
      });
    case C.MERGE_DOMAIN_RESOURCE:
      return [...state, ...action.payload];
    case C.REMOVE_DOMAIN_RESOURCE:
      return state.filter(resource => resource.id !== action.payload);
    default:
      return state;
  }
};
export const user_notes = (state = [], action) => {
  switch (action.type) {
    case C.SET_USER_NOTE:
      return action.payload;
    case C.ADD_USER_NOTE:
      return [...state, action.payload];
    case C.REMOVE_USER_NOTE:
      return state.filter(notes => notes.id !== action.payload);
    case C.UPDATE_USER_NOTE:
      return state.map(note => {
        return note.id !== action.payload.id ? note : action.payload;
      });
    default:
      return state;
  }
};

export const user = (state = null, action) => {
  switch (action.type) {
    case C.SET_USER:
      return action.payload;
    case C.REMOVE_USER:
      return null;
    default:
      return state;
  }
};
export const allUsers = (state = [], action) => {
  switch (action.type) {
    case C.SET_ALL_USERS:
      return action.payload;
    case C.ADD_SINGLE_USER:
      return [action.payload, ...state];
    case C.REMOVE_SINGLE_USER:
      return state.filter(user => user.id !== action.payload);
    case C.REMOVE_ALL_USERS:
      return null;
    case C.UPDATE_ALL_USERS:
      return state.map(user => {
        return user.id !== action.payload.id ? user : action.payload;
      });
    default:
      return state;
  }
};
export const apiKey = (state = null, action) => {
  switch (action.type) {
    case C.SET_API_KEY:
      return action.payload;
    case C.CLEAR_API_KEY:
      return null;
    default:
      return state;
  }
};

export const adminApiKey = (state = null, action) => {
  switch (action.type) {
    case C.SET_ADMIN_API_KEY:
      return action.payload;
    case C.CLEAR_ADMIN_API_KEY:
      return null;
    default:
      return state;
  }
};
export const errors = (state = [], action) => {
  switch (action.type) {
    case C.ADD_ERROR:
      return [...state, action.payload];
    case C.CLEAR_ERROR:
      return state.filter((message, index) => index !== action.payload);
    default:
      return state;
  }
};

const appReducer = combineReducers({
  intro,
  header_text,
  lineImage,
  adminApiKey,
  apiKey,
  user,
  allUsers,
  category,
  domain_resourses,
  user_notes,
  question,
  clipBoardQuestion,
  ads,
  errors
});
// const rootReducer = (state, action) => {
//   if (action.type === C.USER_LOGOUT) {
//     state = undefined;
//   }
//   return appReducer(state, action);
// };

export default appReducer;
//export default rootReducer;
